import React, { memo, useMemo, useState, useEffect } from 'react';
import style from './index.module.scss';
import { Popup } from 'antd-mobile';
import cls from 'classnames';
import { useMallParams, orderingList } from '@/stores';

interface Props {
  initValue?: string;
}

const Fator: React.FC<Props> = ({ initValue }) => {
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState<string>('');
  const { updateMallParams } = useMallParams();
  const handleClickItem = (val: string) => {
    setValue(val);
    updateMallParams({
      ordering: val,
    });
    setTimeout(() => {
      setVisible(false);
    }, 0);
  };
  const label = useMemo(() => {
    return orderingList.find((item) => item.value === value)?.label || '';
  }, [value]);
  useEffect(() => {
    if (!!initValue) {
      setValue(initValue);
    }
  }, [initValue]);
  return (
    <div className={style.sort}>
      <span className={style.pickTri} onClick={() => setVisible(true)}>
        {label}
        <span className="icon-caret"></span>
      </span>
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        bodyStyle={{ height: '52vh' }}
      >
        <div className={style.popup}>
          <div className={style.header}>
            Sort by
            <span className={style.close} onClick={() => setVisible(false)}>
              <span className="close-icon"></span>
            </span>
          </div>
          <div className={style.main}>
            {orderingList.map((item) => (
              <div
                key={item.value}
                className={cls(
                  style.item,
                  item.value === value ? style.activeItem : '',
                )}
                onClick={() => handleClickItem(item.value)}
              >
                {item.label}
                {item.value === value && <span className="hook-icon"></span>}
              </div>
            ))}
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default memo(Fator);
